import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from '../ui/button';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav data-testid="navbar" className="fixed top-0 w-full z-50 glass-nav border-b border-slate-100/50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
            <div className="w-10 h-10 bg-slate-900 flex items-center justify-center">
              <span className="text-white font-bold text-lg font-serif">R</span>
            </div>
            <div className="hidden sm:block">
              <p className="font-serif font-semibold text-slate-900 text-lg leading-tight">Riya AlcoBev</p>
              <p className="text-xs text-slate-500 tracking-wider uppercase">Solutions</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
                className={`text-sm font-medium tracking-wide transition-colors duration-300 link-underline ${
                  isActive(link.path)
                    ? 'text-blue-600'
                    : 'text-slate-600 hover:text-slate-900'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a href="tel:+919686777558" className="flex items-center gap-2 text-slate-600 hover:text-blue-600 transition-colors">
              <Phone className="w-4 h-4" />
              <span className="text-sm font-medium">+91 9686777558</span>
            </a>
            <Link to="/contact">
              <Button 
                data-testid="navbar-cta"
                className="bg-slate-900 text-white hover:bg-slate-800 rounded-none px-6 py-2 text-sm font-semibold uppercase tracking-wider btn-shadow"
              >
                Get in Touch
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-slate-600 hover:text-slate-900"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t border-slate-100">
          <div className="px-6 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
                className={`block text-base font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-blue-600'
                    : 'text-slate-600 hover:text-slate-900'
                }`}
                onClick={() => setIsOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 border-t border-slate-100">
              <a href="tel:+919686777558" className="flex items-center gap-2 text-slate-600 mb-4">
                <Phone className="w-4 h-4" />
                <span className="text-sm font-medium">+91 9686777558</span>
              </a>
              <Link to="/contact" onClick={() => setIsOpen(false)}>
                <Button className="w-full bg-slate-900 text-white hover:bg-slate-800 rounded-none py-3 text-sm font-semibold uppercase tracking-wider">
                  Get in Touch
                </Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
